import React, { useEffect, useState } from "react";
import useAxios from "../../utils/useAxios";
import { hideModal, showModal } from "../../utils/modalUtility";
import RichTextEditor from "../RichTextEditor";
import Pagination from "../common/pagination";
import Select from "react-select";

const SubCategory = () => {
  const [isEditMode, setIsEditMode] = useState(false);
  const [loading, setLoading] = useState(false);
  const [currentUserId, setCurrentUserId] = useState(null);
  const [subCategory, setSubCategory] = useState([]);
  const [category, setCategory] = useState([]);
  const [slugError, setSlugError] = useState("");
  const [originalSlug, setOriginalSlug] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  // React Select selected items
  const [selectedItems, setSelectedItems] = useState([]);

  const axiosAPI = useAxios();

  const [formData, setFormData] = useState({
    cat_name: "",
    description: "",
    media_url: "",
    category_ids: [],
    slug: "",
    is_active_or_inactive_status: "",
    heading: "",
    meta_title: "",
    meta_description: "",
  });

  function removeFormData() {
    setFormData({
      cat_name: "",
      description: "",
      media_url: "",
      category_ids: [],
      slug: "",
      is_active_or_inactive_status: "",
      heading: "",
      meta_title: "",
      meta_description: "",
    });
    setSlugError("");
  }

  const categoryOptions = category?.map((item) => ({
    value: item.id,
    label: item.cat_name,
  }));

  // console.log("Category Options", categoryOptions);

  const closeModal = () => {
    setIsEditMode(false);
    removeFormData();
    setCurrentUserId(null);
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    // setFormData({ ...formData, [e.target.id]: e.target.value });
    if (id === "cat_name") {
      const slug = value.toLowerCase().replace(/\s+/g, "-");
      setFormData({
        ...formData,
        cat_name: value,
        slug: slug,
      });
    } else {
      setFormData({
        ...formData,
        [id]: value,
      });
    }
  };

  function openAddProductModal() {
    removeFormData(); //  Clear the form

    setTimeout(() => {
      setIsEditMode(false); //  Ensure it's not in edit mode
      showModal("newUserModal");
    }, 100);
  }
  async function fetchSubCategory() {
    try {
      setLoading(true);
      const response = await axiosAPI.get(
        `/api/v1/get-sub-categories?page=${page}`
      );
      setSubCategory(response?.data?.categories);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchSubCategory();
  }, [page]);

  async function fetchCategory() {
    try {
      setLoading(true);
      const response = await axiosAPI.get("/api/v1/get-categories");

      const categories = response?.data?.categories;

      const limitedData = categories?.map(({ id, cat_name }) => ({
        id,
        cat_name,
      }));

      setCategory(limitedData);
      setTotalPages(response?.data?.totalPages);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      // Always turn off loading, whether success or error
      setLoading(false);
    }
  }

  async function validateSlugUnique(slug) {
    try {
      console.log("Slug is ", slug);
      const response = await axiosAPI.get(`/api/v1/check-sub-cat-slug/${slug}`);

      if (response.data.success) {
        // Slug is available
        setSlugError(""); // Clear error
        return true; // valid slug
      } else {
        // Slug already exists
        setSlugError(
          response.data.message ||
            "Slug already exists. Please choose a different one."
        );
        return false; // invalid slug
      }
    } catch (error) {
      console.error("Error checking slug:", error);
      setSlugError("Error checking slug. Please try again.");
      return false; // consider invalid on error
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.slug) {
      setSlugError("Slug is required");
      return;
    }

    if (!isEditMode || formData.slug !== originalSlug) {
      const isSlugValid = await validateSlugUnique(formData.slug);
      if (!isSlugValid) return;
    }

    const payload = {
      cat_name: formData.cat_name,
      description: formData.description,
      media_url: formData.media_url,
      category_ids: formData.category_ids,
      slug: formData.slug,
      heading: formData.heading,
      meta_title: formData.meta_title,
      meta_description: formData.meta_description,
    };

    console.log("Payload to submit", payload);

    // return;

    try {
      if (isEditMode) {
        await axiosAPI.put(
          `/api/v1/update-sub-category/${currentUserId}`,
          payload
        );
        window.notifyMessage(
          "Success",
          "Category Details Updated successfully",
          "success"
        );
      } else {
        await axiosAPI.post(`/api/v1/add-sub-category`, payload);
        window.notifyMessage(
          "Success",
          "Category Details added successfully",
          "success"
        );
      }

      removeFormData();
      hideModal("newUserModal"); //  then hide modal
      fetchSubCategory(); //  finally, refresh list
    } catch (error) {
      const message = error?.response?.data?.message || "There was an error!";
      window.notifyMessage("Error", message, "danger");
    }
  };

  const openEditModal = (categoryId) => {
    setIsEditMode(true);
    showModal("newUserModal");
    setCurrentUserId(categoryId);

    console.log("user id", categoryId);

    const categoryToEdit = subCategory.find(
      (category) => category.id === categoryId
    );

    // console.log(categoryToEdit);

    setFormData({
      cat_name: categoryToEdit.name,
      description: categoryToEdit.description,
      media_url: categoryToEdit.media_url,
      category_ids: categoryToEdit.category_ids,
      slug: categoryToEdit.slug,
      heading: categoryToEdit.heading,
      meta_title: categoryToEdit.meta_title,
      meta_description: categoryToEdit.meta_description,
    });
    setOriginalSlug(categoryToEdit.slug);
  };

  const handleDelete = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this?");
    if (!isConfirmed) return;

    try {
      const response = await axiosAPI.delete(
        `/api/v1/delete-sub-category/${id}`
      );
      window.notifyMessage("Success", "Deleted successfully", "success");
      fetchSubCategory();
    } catch (error) {
      console.error("Error deleting:", error);
      window.notifyMessage(
        "Error",
        "An error occurred while deleting.",
        "danger"
      );
    }
  };

  function shortText(text) {
    if (text.length > 50) {
      return `${text.slice(0, 50)}...`;
    }
    return text;
  }

  async function changeSubCategoryStatus(e, commentId) {
    const currentStatus = e.target.value;

    // console.log("Category  Id", commentId);
    // console.log("Current Status", currentStatus);

    try {
      const isConfirmed = window.confirm(
        "Are you sure you want to change the sub category card status?"
      );
      if (!isConfirmed) return;

      const response = await axiosAPI.put(
        `/api/v1/change-subcategory-status/${commentId}`,
        { status: currentStatus }
      );

      fetchSubCategory();
      window.notifyMessage(
        "Success",
        "Sub Category status changed successfully",
        "success"
      );
    } catch (error) {
      console.error("Error changing category status:", error);
      window.notifyMessage(
        "Error",
        "Failed to change sub category status. Please try again.",
        "danger"
      );
    }
  }

  useEffect(() => {
    fetchSubCategory();
    fetchCategory();
  }, []);

  return (
    <div className="container">
      <div className="page-inner">
        <div className="d-flex justify-content-end align-items-end flex-column flex-md-row">
          <div>
            <button
              type="button"
              className="btn btn-dark btn-round mb-4"
              onClick={() => openAddProductModal()}
            >
              Add New Sub Category
            </button>
          </div>
        </div>

        <div
          className="modal fade"
          id="newUserModal"
          tabIndex="-1"
          aria-labelledby="newUserModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="newUserModalLabel">
                  {isEditMode ? "Edit sub Category" : "Add sub Category"}
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleSubmit}>
                  {/* Category Name */}
                  <div className="mb-3">
                    <label htmlFor="cat_name" className="form-label">
                      Sub Category Name
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="cat_name"
                      placeholder="Enter sub Category name"
                      value={formData.cat_name}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* <div className="mb-3">
                    <label htmlFor="category_id" className="form-label">
                      Category Id
                    </label>
                    <select
                      className="form-select"
                      id="category_id"
                      value={formData?.category_id || ""}
                      onChange={handleChange}
                    >
                      <option value="" disabled>
                        Select Category
                      </option>
                      {category?.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.cat_name}
                        </option>
                      ))}
                    </select>
                  </div> */}
                  <div className="mb-3">
                    <label htmlFor="category_ids" className="form-label">
                      Categories
                    </label>
                    <Select
                      id="category_ids"
                      options={categoryOptions}
                      isMulti
                      //  Ensure category_ids is always an array
                      value={categoryOptions.filter((option) =>
                        (formData.category_ids || []).includes(option.value)
                      )}
                      onChange={(selectedOptions) => {
                        // React-Select already gives all selected values
                        const newIds =
                          selectedOptions?.map((opt) => opt.value) || [];
                        setFormData({
                          ...formData,
                          category_ids: newIds, // replace with new selection
                        });
                      }}
                      placeholder="Select Category"
                      isClearable
                    />
                  </div>

                  {/* Media Url */}
                  <div className="mb-3">
                    <label htmlFor="media_url" className="form-label">
                      Media Url
                    </label>
                    <textarea
                      type="text"
                      rows={4}
                      className="form-control"
                      id="media_url"
                      placeholder="Enter media url "
                      value={formData.media_url}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* Meta Title */}
                  <div className="mb-3">
                    <label htmlFor="meta_title" className="form-label">
                      Meta Title
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="meta_title"
                      placeholder="Enter meta title"
                      value={formData.meta_title}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* Meta Description */}
                  <div className="mb-3">
                    <label htmlFor="meta_description" className="form-label">
                      Meta Description
                    </label>
                    <textarea
                      type="text"
                      rows={4}
                      className="form-control"
                      id="meta_description"
                      placeholder="Enter meta Description"
                      value={formData.meta_description}
                      onChange={handleChange}
                    />
                  </div>
                  {/* Heading */}
                  <div className="mb-3">
                    <label htmlFor="heading" className="form-label">
                      Heading
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="heading"
                      placeholder="Enter heading "
                      value={formData.heading}
                      onChange={handleChange}
                      required
                    />
                  </div>
                  {/* Category Description */}
                  <div className="mb-3">
                    <label htmlFor="description" className="form-label">
                      Category Description
                    </label>
                    {/* <textarea
                      type="text"
                      rows={4}
                      className="form-control"
                      id="description"
                      placeholder="Enter sub category Description"
                      value={formData.description}
                      onChange={handleChange}
                    /> */}

                    <RichTextEditor
                      formData={formData}
                      setFormData={setFormData}
                    />
                  </div>
                  {/* Slug */}
                  <div className="mb-3">
                    <label htmlFor="slug" className="form-label">
                      Slug
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      id="slug"
                      placeholder="Enter sub category slug"
                      value={formData.slug}
                      onChange={handleChange}
                      required
                    />
                    {slugError && (
                      <small className="text-danger">{slugError}</small>
                    )}
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary btn-round btn-sm"
                  >
                    {isEditMode ? "Update Sub Category" : "Add Sub Category"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Category Table */}
        <div className="row">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <h4 className="card-title">
                  All Sub Category ({subCategory?.length})
                </h4>
              </div>
              <div className="card-body">
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Category Name</th>
                        <th>Description</th>
                        <th>Media Url</th>
                        <th>Heading</th>
                        <th>Meta Title</th>
                        <th>Meta Description</th>
                        <th>Slug</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            Loading...
                          </td>
                        </tr>
                      ) : subCategory?.length === 0 ? (
                        <tr>
                          <td colSpan="8" className="text-center">
                            No Category found.
                          </td>
                        </tr>
                      ) : (
                        subCategory.map((cat) => (
                          <tr key={cat.id}>
                            <td>{cat?.name}</td>
                            <td>{shortText(cat?.description)}</td>
                            <td>{shortText(cat?.media_url)}</td>
                            <td>{shortText(cat?.heading || "")}</td>
                            <td>{shortText(cat?.meta_title || "")}</td>
                            <td>{shortText(cat?.meta_description || "")}</td>

                            <td>{cat?.slug}</td>
                            <td>
                              <select
                                className="form-select"
                                value={cat.is_active_or_inactive}
                                onChange={(e) =>
                                  changeSubCategoryStatus(e, cat?.id)
                                }
                              >
                                <option value="YES">Yes</option>
                                <option value="NO">No</option>
                              </select>
                            </td>
                            <td>
                              <button
                                className="btn btn-icon btn-round btn-dark btn-sm me-2"
                                onClick={() => openEditModal(cat.id)}
                              >
                                <i className="fas fa-edit"></i>
                              </button>
                              <button
                                className="btn btn-icon btn-round btn-danger btn-sm me-2"
                                onClick={() => handleDelete(cat.id)}
                              >
                                <i className="fas fa-trash"></i>
                              </button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

            <Pagination totalPages={totalPages} setPage={setPage} page={page} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubCategory;
